// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.participants[data-v-2541fccf] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.participants__section[data-v-2541fccf] {\n  margin-top: 20px;\n}\n.participants-section__wrapper[data-v-2541fccf] {\n  width: 100%;\n}\n.participants-section__description[data-v-2541fccf] {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
